module.exports = __webpack_public_path__ + "static/media/iconTarget.9869a8db.svg";